// CRM Companies — crm_companies.* (menu_item_id 45, CRM)
//
// The optional organisation behind a CRM contact, created by the "Create Company"
// step of lead conversion. Registered by the amer-laravel migration
// 2026_08_05_000008_add_crm_structure_refactor_permissions. The ids below are the
// central-assigned approval numbers and must be confirmed against the central
// permission-key registry before release.

/** crm_companies.index */
export const CRM_COMPANIES_INDEX = 1447;
/** crm_companies.store */
export const CRM_COMPANIES_STORE = 1448;
/** crm_companies.show */
export const CRM_COMPANIES_SHOW = CRM_COMPANIES_INDEX;
/** crm_companies.update */
export const CRM_COMPANIES_UPDATE = 1450;
/** crm_companies.destroy */
export const CRM_COMPANIES_DESTROY = 1451;
